"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PACKAGES_LOADED = exports.PACKAGES_LOADED = "PACKAGES_LOADED";
var PACKAGES_RUN = exports.PACKAGES_RUN = "PACKAGES_RUN";
var PACKAGES_START = exports.PACKAGES_START = "PACKAGES_START";
var PACKAGES_STOP = exports.PACKAGES_STOP = "PACKAGES_STOP";
var PACKAGES_UPLOADED = exports.PACKAGES_UPLOADED = "PACKAGES_UPLOADED";
var PACKAGES_DEPENDENCY_NAMES = exports.PACKAGES_DEPENDENCY_NAMES = ["dependencies", "devDependencies", "optionalDependencies"];
//# sourceMappingURL=packagesConstants.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/packages/packagesConstants.js
// module id = 100
// module chunks = 0